import { gql } from '@apollo/client'

const DeleteTrack = gql`
    mutation DeleteTrack($trackId: ID!) {
        deleteTrack(trackId: $trackId)
    }
`

export default DeleteTrack
